<template>
<div class="svg-container-outer">
    <div class="svg-container">
        <div class="button-container">
            <div class="print-selected close-label">
                <p class="print-selected-text download-csv" @click="listOldManifestShipmentsFunc()">Refresh Table</p>
            </div>
        </div>
        <div class="manifest-text-container">
            <h3>Delayed Manifest Shipments</h3>
        </div>
        <loading-charts v-if="loadingData" class="loading-charts"/>
        <table-filter 
        :filterByShipmentID="true"
        :filterByRouteCode="true"
        @filterValues="filterValues($event)"/>
        <div class="table-container-main">
            <div class="responsive-table">
                <div class="table-header" id="header">
                    <div class="col-1 sortable" @click="sortBy('shipmentID')">
                        Shipment ID
                        <span v-if="sortKey === 'shipmentID'">
                            {{ sortDirection === 'asc' ? '▲' : '▼' }}
                        </span>
                    </div>

                    <div class="col-2 sortable" @click="sortBy('address')">
                        Address
                        <span v-if="sortKey === 'address'">
                            {{ sortDirection === 'asc' ? '▲' : '▼' }}
                        </span>
                    </div>

                    <div class="col-3 sortable" @click="sortBy('expectedDispatchDateTime')">
                        Expected Dispatch
                        <span v-if="sortKey === 'expectedDispatchDateTime'">
                            {{ sortDirection === 'asc' ? '▲' : '▼' }}
                        </span>
                    </div>

                    <div class="col-4 sortable" @click="sortBy('route')">
                        Route
                        <span v-if="sortKey === 'route'">
                            {{ sortDirection === 'asc' ? '▲' : '▼' }}
                        </span>
                    </div>
                </div>
                <loading-charts v-if="loadingTable" class="loading-charts"/>
                <div class="table-row-container">
                    <div class="table-row" v-for="(shipment, index) in sortedDelayedManifestShipments" :key="index">
                        <div @click="trackShipment(shipment.shipmentID)" class="col-1"><p class="shipmentid-text" id="shipmentid-text">{{shipment.shipmentID}}</p></div>
                        <div class="col-2 col-data"><span style="font-weight: bold;">{{shipment.address.companyName}}</span> {{shipment.address.address1}}, {{shipment.address.city}}, {{shipment.address.state}}, {{shipment.address.zipCode}}</div>
                        <div class="col-3 col-data"><p class="service-text">{{shipment.expectedDispatchDate}}</p></div>
                        <div class="col-4 col-data"><p class="service-text">{{shipment.route}}</p></div>
                    </div>
                </div>
                <div v-if="(sortedDelayedManifestShipments.length == 0)" class="table-row-container">
                    <div class="table-row">
                        <div class="col-1"><p class="shipmentid-text" id="shipmentid-text"></p></div>
                        <div class="col-2 col-data">No Shipments</div>
                        <div class="col-3 col-data"><p class="service-text"></p></div>
                        <div class="col-4"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="button-container">
            <div class="print-selected close-label">
                <p class="print-selected-text download-csv" @click="downloadCSVTest()">Download CSV</p>
            </div>
        </div>
    </div>
</div>

<shipment-info v-if="toggleTrackShipment" @closeShipmentInfo="closeShipmentInfo($event)" :trackShipmentID="trackShipmentID" :cognitoUser="cognitoUser" :userData="userData"/>
<alert-user  v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/>
</template>

<script>
import {API} from 'aws-amplify';
import ShipmentInfo from './../ShipmentInfo.vue'
import LoadingCharts from '../../ShipmentDashboard/LoadingCharts.vue'
import TableFilter from './../TableFilter.vue'
import AlertUser from '../../Popups/AlertUser.vue';
import jsonexport from 'jsonexport'


export default {
    components:{
        ShipmentInfo,
        LoadingCharts,
        TableFilter,
        AlertUser
    },
    props: ['userData', 'cognitoUser', 'filterByTripSheetID'],
    data(){
        return{
            trackShipmentID: null,
            toggleTrackShipment: false,
            user: null,
            loadingData: false,
            loadingTable: false,
            isFiltered: false,
            filterField: '',
            filterValue: '',
            toggleAlertBox: '',
            alertMessage: '',
            delayedManifestShipments: [],
            alldelayedManifestShipments: [],
            sortKey: 'expectedDispatchDateTime',
            sortDirection: 'asc'
        }
    },
    mounted(){
        this.listOldManifestShipmentsFunc();
    },
    computed: {
        sortedDelayedManifestShipments() {
            let sorted = [...this.delayedManifestShipments];

            if (!this.sortKey) {
                return sorted;
            }

            sorted.sort((a, b) => {
                let valueA = this.getSortValue(a, this.sortKey);
                let valueB = this.getSortValue(b, this.sortKey);

                if (valueA == null) valueA = '';
                if (valueB == null) valueB = '';

                if (this.sortKey === 'expectedDispatchDateTime') {
                    valueA = new Date(valueA).getTime();
                    valueB = new Date(valueB).getTime();
                } else {
                    valueA = valueA.toString().toLowerCase();
                    valueB = valueB.toString().toLowerCase();
                }

                if (valueA < valueB) {
                    return this.sortDirection === 'asc' ? -1 : 1;
                }

                if (valueA > valueB) {
                    return this.sortDirection === 'asc' ? 1 : -1;
                }

                return 0;
            });

            return sorted;
        }
    },
    methods:{
        sortBy(key) {
            if (this.sortKey === key) {
                this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
            } else {
                this.sortKey = key;
                this.sortDirection = 'asc';
            }
        },

        getSortValue(shipment, key) {
            switch (key) {
                case 'shipmentID':
                    return shipment.shipmentID;

                case 'address':
                    return `${shipment.address?.companyName || ''} ${shipment.address?.address1 || ''} ${shipment.address?.city || ''} ${shipment.address?.state || ''} ${shipment.address?.zipCode || ''}`;

                case 'expectedDispatchDateTime':
                    return `${shipment.expectedDispatchDate || ''}T${shipment.expectedDispatchTime || '00:00'}:00`;

                case 'route':
                    return shipment.route;

                default:
                    return shipment[key];
            }
        },
        async runFilter(event) {
            await this.filterValues(event);
        },
        filterShipmentID(shipmentID) {

            if (!shipmentID) {
                this.delayedManifestShipments = [...this.alldelayedManifestShipments];
                return;
            }

            const search = shipmentID.toLowerCase();

            this.delayedManifestShipments = this.alldelayedManifestShipments.filter(shipment =>
                shipment.shipmentID?.toLowerCase().includes(search)
            );
        },

        filterRouteCode(routeCode) {

            if (!routeCode) {
                this.delayedManifestShipments = [...this.alldelayedManifestShipments];
                return;
            }

            const search = routeCode.toLowerCase();

            this.delayedManifestShipments = this.alldelayedManifestShipments.filter(shipment =>
                shipment.route?.toLowerCase().includes(search)
            );
        },
        async filterValues(event) {
            console.log("FILTER");

            this.isFiltered = true;
            this.filterField = event.filterField;
            this.filterValue = event.filterValue;

            switch (event.filterField) {

                case "shipmentID":
                    this.filterShipmentID(this.filterValue);
                    break;

                case "routeCode":
                    this.filterRouteCode(this.filterValue);
                    break;

                default:
                    this.delayedManifestShipments = [...this.alldelayedManifestShipments];
                    break;
            }

            this.isFiltered = false;
        },
        async listOldManifestShipmentsFunc() {
            this.loadingData = true;
            this.delayedManifestShipments = [];

            let graphqlQuery = `
                query manifestShipmentByExpectedDispatchDate(
                    $expectedDispatchDate: String!
                    $expectedDispatchTime: ModelStringKeyConditionInput
                    $nextToken: String
                    $limit: Int
                ) {
                    manifestShipmentByExpectedDispatchDate(
                        expectedDispatchDate: $expectedDispatchDate
                        expectedDispatchTime: $expectedDispatchTime
                        nextToken: $nextToken
                        limit: $limit
                    ) {
                        items {
                            shipmentIDAssignedShippingEvent
                            shipmentID
                            assignedShippingEvent
                            assignedActivities
                            route
                            status
                            longitude
                            latitude
                            isDelivery
                            isPriority
                            externalTrackingNumber
                            expectedDispatchDate
                            expectedDispatchTime
                            addedOn
                            address {
                                companyName
                                address1
                                address2
                                city
                                state
                                zipCode
                                longitude
                                latitude
                                relevance
                            }
                        }
                        nextToken
                    }
                }
            `;

            try {
                let allManifestShipments = [];
                const now = new Date();

                // Check the last 7 days. Increase if needed.
                for (let i = 7; i >= 0; i--) {
                    const date = new Date();
                    date.setDate(date.getDate() - i);

                    const expectedDispatchDate = date.toISOString().slice(0, 10);
                    let nextToken = null;

                    do {
                        let response = await API.graphql({
                            query: graphqlQuery,
                            authMode: "AMAZON_COGNITO_USER_POOLS",
                            variables: {
                                expectedDispatchDate,
                                limit: 1000,
                                nextToken
                            }
                        });

                        const data = response.data.manifestShipmentByExpectedDispatchDate;

                        allManifestShipments = [
                            ...allManifestShipments,
                            ...(data.items || [])
                        ];

                        nextToken = data.nextToken;
                    } while (nextToken);
                }

                this.alldelayedManifestShipments = allManifestShipments.filter(item => {
                    if (!item.expectedDispatchDate) return false;

                    const expectedDispatchTime = item.expectedDispatchTime || "00:00";

                    const expectedDateTime = new Date(
                        `${item.expectedDispatchDate}T${expectedDispatchTime}:00`
                    );

                    return expectedDateTime < now;
                });

                this.delayedManifestShipments = [...this.alldelayedManifestShipments];

                this.loadingData = false;
            } catch (e) {
                console.log(e);
                this.toggleAlertBox = true;
                this.alertMessage = "Error getting old manifest shipments.";
                this.loadingData = false;
            }
        },
        trackShipment(shipmentID){
            this.toggleTrackShipment = true;
            this.trackShipmentID = shipmentID;
        },
        closeShipmentInfo(event){
            this.toggleTrackShipment = event;
        },
        closeAlertBox(toggleAlertBox){
            this.toggleAlertBox = toggleAlertBox;
        },
        async downloadCSVTest(){
            this.loadingTable = true;
            let csvArray;

            csvArray = this.delayedManifestShipments.map(obj =>{
                return {
                    shipmentID: obj.shipmentID,
                    route: obj.route,
                    DeliveryCompanyName: obj.address.companyName,
                    DeliveryAddress1: obj.address.address1,
                    DeliveryAddress2: obj.address.address2,
                    DeliveryCity: obj.address.city,
                    DeliveryState: obj.address.state,
                    DeliveryZipCode: obj.address.zipCode,
                    TripSheetID: obj.tripSheetID,
                    Status: obj.status,
                    ExpectedDispatchDate: obj.expectedDispatchDate ?? "ERROR",
                    ExpectedDispatchTime: obj.expectedDispatchTime ?? "ERROR",
                    ExternalTrackingNumber: obj.externalTrackingNumber ?? "ERROR"
                }
            })
            jsonexport(csvArray, (error, csv) => {
                if (error) {
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error downloading manifest shipments"
                }
                const blob = new Blob([csv], { type: 'text/csv' });
                const anchor = document.createElement('a');
                anchor.href = window.URL.createObjectURL(blob);
                anchor.download = 'DelayedManifestShipments.csv';
                anchor.click();
                window.URL.revokeObjectURL(anchor.href);
                anchor.remove();
                this.loadingTable = false;
            })
        }
    }
}
</script>

<style scoped>
.sortable {
    cursor: pointer;
    user-select: none;
}

.sortable:hover {
    filter: brightness(.95);
}

.manifest-text-container{
    display: flex;
    justify-content: flex-start;
}

.manifest-text-container h3{
    margin-top: 5px;
    margin-bottom: 5px;
    background-color: #e4e4e4;
    padding: 5px;
    border-radius: 999px;
}

.table-container-main {
	width: 100%;
	margin-top: 0;
	overflow-x: hidden;
	resize: both;
	height: 350px
}

.responsive-table {
	width: 100%
}

* {
	scrollbar-width: auto;
	scrollbar-color: #f3f3f3 #fff
}

::-webkit-scrollbar {
	width: 16px
}

::-webkit-scrollbar-track {
	background: #fff
}

::-webkit-scrollbar-thumb {
	background-color: #f3f3f3;
	border-radius: 10px;
	border: 3px solid #fff
}

.table-header {
	display: flex;
	flex-direction: row;
	align-items: center;
	background-color: #32ccfe;
	margin-bottom: 10px;
	padding: 5px;
	border-radius: 5px;
	color: #fff;
	position: sticky;
	top: 0
}

.table-row-container {
	height: 100%;
	overflow-y: auto;
	border-radius: 5px;
	width: 100%;
	animation: animate-table-row 1s ease
}

@keyframes animate-table-row {
	from {
		margin-left: -50px
	}

	to {
		margin-left: 0
	}
}

.table-row {
	display: flex;
	flex-direction: row;
	align-items: center;
	background-color: #f3f3f3;
	margin-bottom: 10px;
	padding: 5px;
	border-radius: 5px
}

.table-header .col-1 {
	margin-right: 5px
}

.col-1 {
	flex-basis: 20%;
	text-align: left;
	white-space: nowrap
}

.col-2 {
	flex-basis: 30%;
	text-align: left;
	margin-left: 5px
}

.col-3 {
	flex-basis: 40%;
	text-align: left;
	margin-left: 5px
}

.col-data {
	text-align: left
}

/* .col-4 {
	flex-basis: 10%;
	text-align: center;
	display: flex;
	justify-content: center;
	align-items: center
} */

.col-4 {
	flex-basis: 10%;
	display: flex;
	justify-content: flex-end;
	align-items: center;
    flex-wrap: wrap;
    word-break: break-word;
    overflow-wrap: break-word;
}

.col-4 p{
    margin-left: 2px;
    /* font-size: .6rem; */
}

.service-text {
	background-color: #d4d4d4;
	padding: 2.5px 10px;
	border-radius: 999px;
	width: fit-content;
	margin: 0;
	font-size: 12px;
    white-space: nowrap;
}

.shipmentid-text {
	margin: 0;
	color: #6a6a6a;
	width: fit-content;
	padding: 2.5px 10px;
	border-radius: 999px;
	background-color: #f3f3f3;
	border: 1px solid #a0a0a0;
	transition-duration: .5s
}

.shipmentid-text:hover {
	filter: brightness(.9);
	cursor: pointer;
	transition-duration: .5s
}

.svg-container-outer{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
}

.svg-container{
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    /* width: 100%;
    background-color: #fff;
    padding: 15px;
    border-radius: 25px;
    min-width: 25%;
    margin: 10px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; */
}

input[type=checkbox] {
	-webkit-appearance: none;
	appearance: none;
	background-color: #fff;
	margin: 0;
	cursor: pointer;
	font: inherit;
	color: #33f18a;
	width: 1.05em;
	height: 1.05em;
	border: .15em solid #33f18a;
	border-radius: .15em;
	display: grid;
	place-content: center;
	transition-duration: .5s
}

input[type=checkbox]:hover {
	background-color: #f3f3f3;
	transition-duration: .5s
}

input[type=checkbox]::before {
	content: "";
	width: .65em;
	height: .65em;
	clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0, 43% 62%);
	transform: scale(0);
	transform-origin: bottom left;
	transition: 120ms transform ease-in-out;
	box-shadow: inset 1em 1em var(--form-control-color);
	background-color: CanvasText
}

input[type=checkbox]:checked::before {
	transform: scale(1)
}

.button-container {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
	width: 100%;
	margin: 0;
	animation: animate-table-row 1s ease
}

.print-selected-text {
	margin: 0;
	margin-bottom: 5px;
	margin-right: 5px;
	padding: 2.5px 10px;
	border-radius: 999px;
	background-color: #f3f3f3;
	border: 1px solid #a0a0a0;
	transition-duration: .5s
}

.download-csv {
	margin-top: 5px
}

.void-selected-text {
	margin: 0;
	margin-bottom: 5px;
	padding: 2.5px 10px;
	margin-bottom: 5px;
	border-radius: 999px;
	background-color: #fe804d;
	border: 1px solid #ff5512;
	color: #fff;
	transition-duration: .5s
}

.print-selected-text:hover {
	filter: brightness(.9);
	cursor: pointer;
	transition-duration: .5s
}

.void-selected-text:hover {
	filter: brightness(.9);
	cursor: pointer;
	transition-duration: .5s
}

.close-label {
	margin-left: auto
}

.label-container {
	width: 100%
}

@media only screen and (max-width:600px) {
	.service-text {
		font-size: 8px
	}

    .svg-container-outer{
        font-size: 10px;
    }
}

@media only screen and (max-width:1135px) {
	.col-1 {
		min-width: 30%
	}
}
</style>